import $ from 'jquery';
import { triggerStateChangedRequest } from '~core';
import { getFontSizeValue } from '~src/ui';
import {
  updateTextBorderColorControl,
  updateTextBorderThicknessControl,
} from '~core/borders';
import { hideAllMenus } from '~core/hideAllMenus';
import { toggleEditorSidebar } from '../sidebarLegacy';
// editorConfig no longer needed for text toolbar icons
import { getState } from '~src/state';
import axios from 'axios';
import { clearSelectionsStyles } from '~src/utils';

export function titleCase(str = '') {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

function changeFontFamily(fontFamily) {
  const activeObject = getState('activeObject');

  // If multiple texts are selected, apply to all
  if (
    activeObject &&
    activeObject.type === 'activeSelection' &&
    typeof activeObject.getObjects === 'function'
  ) {
    const texts = activeObject
      .getObjects()
      .filter((o) => o.type === 'textbox' || o.type === 'i-text');
    if (texts.length) {
      texts.forEach((t) => {
        try {
          clearSelectionsStyles(t, 'fontFamily');
          t.fontFamily = fontFamily;
          t.set('dirty', true);
        } catch (e) {
          console.error('Failed applying fontFamily to selection', e);
        }
      });
      window.canvas.renderAll();
      triggerStateChangedRequest();
      return;
    }
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontFamily');
      activeObject.fontFamily = fontFamily;
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      activeObject.fontFamily = fontFamily;
    } else {
      // a portion of text was selected
      activeObject.setSelectionStyles({ fontFamily });
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontFamily');
    activeObject.fontFamily = fontFamily;
  }
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

// TODO: [DEV-344] review why activeObject is not used
// function changeTextAlign(textAlign) {
//   const activeObject = getState('activeObject');

//   if (activeObject.isEditing) {
//     activeObject.setSelectionStyles({ textAlign });
//   } else {
//     activeObject.textAlign = textAlign;
//   }

//   window.canvas.renderAll();
//   toggleTextAlignPopper();
// }

function onFontFamilyChange(e) {
  e.preventDefault();
  const fontFamily = $(this).data('font-family');
  return changeFontFamily(fontFamily);
}

const beautifyFontName = (rawFontName) => {
  return titleCase(rawFontName.replace(/-/g, ' '));
};

const loadFonts = async () => {
  const {
    data: { websafe, google, custom, adobe, adobeProjectId },
  } = await axios.get(`${process.env.OFC_CDN_URL}/fonts/index.json`);

  const orderedFontFamilies = [
    ...websafe,
    ...google,
    ...custom,
    ...adobe,
  ].sort();
  const fontItems = orderedFontFamilies.reduce((acc, fontName) => {
    const item = `<div data-font-family="${fontName}" data-search-font-family="${fontName.toLowerCase()}" class="font-item" style="font-family:${fontName}">${beautifyFontName(
      fontName
    )}</div>`;
    acc += item;
    return acc;
  }, '');

  return new Promise((resolve) => {
    window.WebFont.load({
      custom: {
        families: custom,
      },
      google: {
        families: google,
      },
      typekit: { id: adobeProjectId, api: '//use.typekit.net' },
      active: () => {
        $('body').off('click', '[data-font-family]');
        $('body').on('click', '[data-font-family]', onFontFamilyChange);
        $('#popper-font-family-scroller').html(fontItems);
        resolve();
      },
    });
  });
};

// Legacy toolbar style updater removed: floating controls handle active states

function changeFontSize(fontSize) {
  if (fontSize > 1) {
    const activeObject = getState('activeObject');
    if (activeObject.isEditing) {
      const { selectionStart, selectionEnd } = activeObject;

      if (
        activeObject.text &&
        selectionStart === 0 &&
        selectionEnd === activeObject.text.length
      ) {
        // everything was selected
        clearSelectionsStyles(activeObject, 'fontSize');
        activeObject.fontSize = fontSize;
      } else if (selectionStart !== selectionEnd) {
        // a portion of text was selected
        activeObject.setSelectionStyles({ fontSize });
      }
    } else {
      clearSelectionsStyles(activeObject, 'fontSize');
      activeObject.set('fontSize', fontSize);
      activeObject.set('dirty', true);
    }
    window.canvas.renderAll();

    triggerStateChangedRequest();
  }
}

function fontSizePlus() {
  let fontSize = getFontSizeValue();
  let fontSizePlusValue = fontSize + 20;
  changeFontSize(fontSizePlusValue);
}

function fontSizeMinus() {
  let fontSize = getFontSizeValue();
  let fontSizePlusValue = fontSize - 20;
  // if (fontSize <= 40) {
  //   document.getElementById('editor-menu-font-size-minus').disabled = true;
  // } else {
  changeFontSize(fontSizePlusValue);
  // }
}

function showMenuText() {
  hideAllMenus();
  // header text toolbar migrated to floating controls
  // object toolbar migrated to floating controls
}

function onObjectTextSelected() {
  const isSidebarOpen = getState('isSidebarOpen');

  showMenuText();
  // Floating controls handle state sync for text. Only update sidebar controls
  // when the Text Border tab is visible to keep legacy sidebar consistent.
  try {
    const isTextBorderTabActive = $('#tab-text-border').hasClass('active');
    if (isSidebarOpen && isTextBorderTabActive) {
      updateTextBorderColorControl();
      updateTextBorderThicknessControl();
    }
  } catch (e) {
    console.error('Failed updating text border controls', e);
  }

  // Hide non-text sidebar
  if (isSidebarOpen && $('.tab.active').length) {
    const tabObjectType = $('.tab.active').first().data('object-type');
    if (tabObjectType !== 'text') {
      toggleEditorSidebar();
    }
  }
}

function hideMenuText() {
  $('#editor-menu-default').show();
  $('#editor-menu-text').hide();
  // object toolbar migrated to floating controls
}

// function hideMenuDefault() {
//   $('#editor-menu-default').hide();
// }

// function hideMenuCrop() {
//   $('#editor-menu-crop').hide();
// }

/**
 * Trigger: text selection has changed
 */
function onSelectTextEditing() {
  // Floating controls listen to text:selection:changed and refresh themselves
}

const isStyleBold = (fontWeight) =>
  fontWeight === 'bold' || parseInt(fontWeight) >= 600;

function toggleFontWeightBold() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const selectionStyles = activeObject.getSelectionStyles();
    const fontWeight =
      selectionStyles && selectionStyles.length > 0 && selectionStyles[0]
        ? selectionStyles[0].fontWeight
        : activeObject.get('fontWeight');
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontWeight');
      if (isStyleBold(activeObject.fontWeight)) {
        activeObject.fontWeight = 'normal';
      } else {
        activeObject.fontWeight = 'bold';
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (isStyleBold(fontWeight)) {
        activeObject.setSelectionStyles({
          fontWeight: 'normal',
        });
      } else {
        activeObject.setSelectionStyles({
          fontWeight: 'bold',
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontWeight');
    if (isStyleBold(activeObject.fontWeight)) {
      activeObject.fontWeight = 'normal';
    } else {
      activeObject.fontWeight = 'bold';
    }
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
}

function toggleFontStlyeItalic() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const styles = activeObject.getSelectionStyles();
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontStyle');
      if (activeObject.fontStyle === 'normal') {
        activeObject.fontStyle = 'italic';
      } else {
        activeObject.fontStyle = 'normal';
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (styles && styles[0] && styles[0].fontStyle === 'italic') {
        activeObject.setSelectionStyles({
          fontStyle: 'normal',
        });
      } else {
        activeObject.setSelectionStyles({
          fontStyle: 'italic',
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontStyle');
    if (activeObject.fontStyle === 'normal') {
      activeObject.fontStyle = 'italic';
    } else {
      activeObject.fontStyle = 'normal';
    }
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
}

function toggleTextUnderline() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const styles = activeObject.getSelectionStyles();
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'underline');
      if (activeObject.get('underline')) {
        activeObject.set('underline', false);
      } else {
        activeObject.set('underline', true);
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (styles && styles[0] && styles[0].underline) {
        activeObject.setSelectionStyles({
          underline: false,
        });
      } else {
        activeObject.setSelectionStyles({
          underline: true,
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'underline');
    if (activeObject.get('underline')) {
      activeObject.set('underline', false);
    } else {
      activeObject.set('underline', true);
    }
    activeObject.set('dirty', true);
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
}

function editorSetTextAlign(textAlign = 'left') {
  const activeObject = getState('activeObject');

  activeObject.set('textAlign', textAlign);
  activeObject.set('dirty', true);
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

function setEditorSetTextSpacingH(charSpacing, saveHistory = false) {
  const activeObject = getState('activeObject');
  activeObject.set('charSpacing', charSpacing);
  activeObject.set('dirty', true);
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function setEditorSetTextSpacingV(lineHeight, saveHistory = false) {
  const activeObject = getState('activeObject');
  activeObject.set('lineHeight', lineHeight);
  activeObject.set('dirty', true);
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function onTextSpacingValueChangeV(e) {
  let value = parseFloat($(this).val());

  // Enforce min/max limits
  const min = 0.5;
  const max = 5;
  if (value < min) value = min;
  if (value > max) value = max;
  if (isNaN(value)) value = min;

  const saveHistory = e.type === 'change';

  // Update both controls to the clamped value
  $('#editor-text-spacing-v-slider').val(value);
  $('#editor-text-spacing-v-value').val(Math.round(value * 100) / 100);

  setEditorSetTextSpacingV(value, saveHistory);
}

function onTextOpacityValueChange(e) {
  const value = $(this).val();
  const activeObject = getState('activeObject');
  const saveHistory = e.type === 'change';
  activeObject.set({ opacity: value });
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function onTextSpacingValueChangeH(e) {
  let value = parseFloat($(this).val());

  // Enforce min/max limits
  const min = -200;
  const max = 1000;
  if (value < min) value = min;
  if (value > max) value = max;
  if (isNaN(value)) value = min;

  const saveHistory = e.type === 'change';

  // Update both controls to the clamped value
  $('#editor-text-spacing-h-slider').val(value);
  $('#editor-text-spacing-h-value').val(Math.round(value * 100) / 100);

  setEditorSetTextSpacingH(value, saveHistory);
}

// Removed header font-size input binding; handled by floating controls

export {
  loadFonts,
  toggleFontWeightBold,
  toggleFontStlyeItalic,
  editorSetTextAlign,
  toggleTextUnderline,
  onTextSpacingValueChangeV,
  onTextSpacingValueChangeH,
  onObjectTextSelected,
  hideMenuText,
  showMenuText,
  onSelectTextEditing,
  fontSizePlus,
  fontSizeMinus,
  onTextOpacityValueChange,
};
